import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportsRoutingModule } from './reports-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CardModule } from 'primeng/card';
import { ResourcesModule } from '../resources/resources.module';
import { ResumenVentasComponent } from './resumen-ventas/resumen-ventas.component';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { EcommerceComponent } from './ecommerce/ecommerce.component';


@NgModule({
  declarations: [DashboardComponent, ResumenVentasComponent, EcommerceComponent],
  imports: [
    CommonModule,
    ResourcesModule,
    ReportsRoutingModule, NgApexchartsModule,
    FormsModule,
    CardModule,
    DatePickerModule,
    NgApexchartsModule,
    DialogModule,
    InputNumberModule,
    ButtonModule,
    SelectModule
  ]
})
export class ReportsModule { }
